export class Music {
	fadeDuration = 500;
	fadeStepsCount = 10;
	fadeInterval = null;
	muted = false;

	constructor(src) {
		this.audio = new Audio(src);
	}

	play({ withFade } = { withFade: false }) {
		this.audio.currentTime = this.audio.currentTime - this.fadeDuration / 1000;
		this.audio.play();
		if (withFade && !this.muted) this.fade(0, 1);
	}

	pause({ withFade } = { withFade: false }) {
		if (!withFade || this.muted) this.audio.pause();
		else this.fade(1, 0).then(() => this.audio.pause());
	}

	mute() {
		this.muted = true;
		this.audio.volume = 0;
	}

	unmute() {
		this.muted = false;
		this.audio.volume = 1;
	}

	async fade(from, to) {
		return new Promise((resolve, reject) => {
			clearInterval(this.fadeInterval);

			const stepAmount = ((to - from) * 100) / this.fadeStepsCount;
			let vol = from * 100;

			this.fadeInterval = setInterval(() => {
				if (this.muted) reject(clearInterval(this.fadeInterval));
				vol += stepAmount;
				if (vol < 0 || vol > 100) resolve(clearInterval(this.fadeInterval));
				else this.audio.volume = vol / 100;
			}, this.fadeDuration / this.fadeStepsCount);
		});
	}
}
